// src/components/chat/TeamInvitePicker.jsx
// Captain team selection modal — pick which team to invite a user to.
import React from 'react';

export default function TeamInvitePicker({
  isOpen,
  captainTeams,
  pickedTeamId,
  setPickedTeamId,
  onClose,
  onContinue,
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[12050] flex items-center justify-center">
      {/* overlay */}
      <div
        className="absolute inset-0 bg-black/40"
        onMouseDown={onClose}
      />

      {/* modal */}
      <div className="relative w-[520px] max-w-[92vw] bg-white rounded-xl shadow-2xl border border-gray-200 overflow-hidden">
        <div className="px-4 py-3 border-b border-gray-200 flex items-center">
          <div className="text-sm font-semibold text-gray-900">
            Select a team to invite them to
          </div>
          <button
            type="button"
            className="ml-auto h-8 w-8 inline-flex items-center justify-center rounded-full hover:bg-gray-100 text-gray-500"
            onClick={onClose}
            aria-label="Close team picker"
            title="Close"
          >
            ×
          </button>
        </div>

        <div className="p-3 max-h-[50vh] overflow-y-auto">
          {(!captainTeams || captainTeams.length === 0) ? (
            <div className="text-sm text-gray-500 p-3">
              No captain teams available.
            </div>
          ) : (
            <div className="space-y-2">
              {captainTeams.map((t) => {
                const id = Number(t?.team_id);
                const selected = Number(pickedTeamId) === id;

                return (
                  <button
                    key={id}
                    type="button"
                    onClick={() => setPickedTeamId(id)}
                    className={[
                      "w-full text-left px-3 py-2 rounded-lg border transition",
                      selected
                        ? "bg-[#00aef7] text-white border-[#00aef7]"
                        : "bg-white text-gray-900 border-gray-200 hover:bg-gray-50",
                    ].join(" ")}
                  >
                    <div className="text-sm font-semibold leading-tight">
                      {t?.team_name || `Team ${id}`}
                    </div>
                    <div className={["text-xs mt-0.5", selected ? "text-white/90" : "text-gray-500"].join(" ")}>
                      {t?.team_city || ''}{t?.team_city && t?.team_state ? ', ' : ''}{t?.team_state || ''}
                    </div>
                  </button>
                );
              })}
            </div>
          )}
        </div>

        <div className="px-4 py-3 border-t border-gray-200 flex items-center justify-end gap-2">
          <button
            type="button"
            className="px-3 py-1.5 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50 text-sm"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="px-3 py-1.5 rounded-md bg-[#00aef7] text-white hover:bg-[#009ad9] text-sm disabled:opacity-60 disabled:cursor-not-allowed"
            disabled={!Number.isFinite(Number(pickedTeamId))}
            onClick={() => {
              const chosenId = Number(pickedTeamId);
              if (!Number.isFinite(chosenId)) return;
              onContinue(chosenId);
            }}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
